import React from 'react';

function UserScoreboard({ users, activeBets }) {
  // Map user emails to profile image paths
  const userProfileImages = {
    "dara.mcgann@gmail.com": "/images/profiles/daz-profile.png",
    "caoimherooney@gmail.com": "/images/profiles/blondie-profile.png",
    "tomas.burke@gmail.com": "/images/profiles/moss-profile.png",
    // Add other mappings as needed
  };

  // Calculate "Pints on Offer" for each user (active bets they're in)
  const getPintsOnOffer = (email) => {
    if (!activeBets) return 0;
    return activeBets.filter(bet =>
      bet.participants_emails && bet.participants_emails.includes(email)
    ).length;
  };

  // Generate initials for profile image
  const getInitials = (name, email) => {
    const displayName = name || email.split('@')[0];
    return displayName.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  return (
    <section>
      <div className="UserScoreboard-container">
        {users.length > 0 ? (
          users.map((u) => (
            <div key={u.email} className="UserScoreboard-item">
              {userProfileImages[u.email] ? (
                <img
                  src={userProfileImages[u.email]}
                  alt={`${u.name || u.email}'s profile`}
                  className="UserScoreboard-profile-image"
                  style={{ borderRadius: '50%', objectFit: 'cover' }} // Ensure image fits circular shape
                />
              ) : (
                <div className="UserScoreboard-profile-image">
                  {getInitials(u.name, u.email)}
                </div>
              )}
              <h3>{u.name || u.email.split('@')[0]}</h3>
              <div className="UserScoreboard-stats">
                <div>
                  <strong>Pints on Offer:</strong> {getPintsOnOffer(u.email)}
                </div>
                <div>
                  <strong>Pints Necked:</strong> {u.wins}
                </div>
                <div>
                  <strong>Down the Drain:</strong> {u.losses}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>No users data available.</p>
        )}
      </div>
    </section>
  );
}

export default UserScoreboard;
